'use client';

import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { slugifyKeywordForUrl, formatKeywordDisplay } from '@/lib/rss';

interface KeywordLinkProps {
  keyword: string;
  className?: string;
  asButton?: boolean;
}

export default function KeywordLink({ keyword, className = '', asButton = false }: KeywordLinkProps) {
  const slug = slugifyKeywordForUrl(keyword);
  const router = useRouter();

  const sharedStyle: React.CSSProperties = {
    background: 'rgba(139,92,246,0.12)',
    color: 'var(--primary)',
    border: '1px solid rgba(139,92,246,0.25)',
    fontFamily: 'var(--font-mono)',
    letterSpacing: '0.05em',
    cursor: 'pointer',
  };

  const handleMouseEnter = (e: React.MouseEvent<HTMLElement>) => {
    (e.currentTarget as HTMLElement).style.background = 'rgba(139,92,246,0.25)';
    (e.currentTarget as HTMLElement).style.borderColor = 'var(--primary)';
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLElement>) => {
    (e.currentTarget as HTMLElement).style.background = 'rgba(139,92,246,0.12)';
    (e.currentTarget as HTMLElement).style.borderColor = 'rgba(139,92,246,0.25)';
  };

  if (asButton) {
    return (
      <span
        role="link"
        tabIndex={0}
        className={`inline-block text-xs px-2 py-0.5 rounded transition-colors ${className}`}
        style={sharedStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          router.push(`/keywords/${slug}`);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            router.push(`/keywords/${slug}`);
          }
        }}
      >
        {formatKeywordDisplay(keyword)}
      </span>
    );
  }

  return (
    <Link
      href={`/keywords/${slug}`}
      className={`inline-block text-xs px-2 py-0.5 rounded transition-colors ${className}`}
      style={sharedStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {formatKeywordDisplay(keyword)}
    </Link>
  );
}
